import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type EventScope = 'occurrence' | 'following' | 'all';

export interface EventScopeDialogData {
  /** 'save' or 'delete': only changes the wording. */
  action: 'save' | 'delete';
}

/** Asks which occurrences of a recurring event a change or delete applies to. Closes with the scope. */
@Component({
  selector: 'app-event-scope-dialog',
  templateUrl: './event-scope-dialog.component.html',
  styleUrls: ['./event-scope-dialog.component.scss']
})
export class EventScopeDialogComponent {
  scope: EventScope = 'occurrence';

  readonly options: { value: EventScope; label: string }[] = [
    { value: 'occurrence', label: 'This event' },
    { value: 'following', label: 'This and following events' },
    { value: 'all', label: 'All events' },
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: EventScopeDialogData) { }

  get title(): string {
    return this.data?.action === 'delete' ? 'Delete recurring event' : 'Edit recurring event';
  }
}
